import { TableStyles } from "react-data-table-component";

export const customStyles: TableStyles = {
  table: {
    style: {
      backgroundColor: "white",
      borderRadius: "0.5rem",
      overflow: "hidden",
      boxShadow:
        "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#f9fafb",
      borderBottomWidth: "1px",
      borderBottomColor: "#e5e7eb",
      color: "#374151",
      fontWeight: "600",
      textTransform: "uppercase",
      fontSize: "0.75rem",
      letterSpacing: "0.05em",
    },
  },
  headCells: {
    style: {
      padding: "16px",
    },
  },
  rows: {
    style: {
      minHeight: "60px",
      fontSize: "0.875rem",
      color: "#4b5563",
      "&:not(:last-of-type)": {
        borderBottomWidth: "1px",
        borderBottomColor: "#f3f4f6",
      },
    },
    highlightOnHoverStyle: {
      backgroundColor: "#f9fafb",
      transitionDuration: "0.15s",
      transitionProperty: "background-color",
      outlineStyle: "solid",
      outlineWidth: "1px",
      outlineColor: "#e5e7eb",
    },
  },
  cells: {
    style: {
      padding: "16px",
    },
  },
  pagination: {
    style: {
      borderTopWidth: "1px",
      borderTopColor: "#e5e7eb",
      backgroundColor: "white",
      color: "#4b5563",
    },
    pageButtonsStyle: {
      borderRadius: "0.375rem",
      height: "32px",
      width: "32px",
      padding: "4px",
      margin: "0 4px",
      cursor: "pointer",
      transition: "0.2s ease-out",
      color: "#4b5563",
      fill: "#4b5563",
      backgroundColor: "transparent",
      "&:disabled": {
        cursor: "not-allowed",
        color: "#d1d5db",
        fill: "#d1d5db",
      },
      "&:hover:not(:disabled)": {
        backgroundColor: "#f3f4f6",
      },
      "&:focus": {
        outline: "none",
        backgroundColor: "#e5e7eb",
      },
    },
  },
};



  // Custom styles for the data table
  export const customStyles_T: TableStyles = {
    table: {
      style: {
        backgroundColor: "white",
        borderRadius: "0.5rem",
        overflow: "hidden",
        boxShadow:
          "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f9fafb",
        borderBottomWidth: "1px",
        borderBottomColor: "#e5e7eb",
        color: "#374151",
        fontWeight: "600",
        textTransform: "uppercase",
        fontSize: "0.75rem",
        letterSpacing: "0.05em",
      },
    },
    headCells: {
      style: {
        padding: "16px",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
        fontSize: "0.875rem",
        color: "#4b5563",
        "&:not(:last-of-type)": {
          borderBottomWidth: "1px",
          borderBottomColor: "#f3f4f6",
        },
      },
      highlightOnHoverStyle: {
        backgroundColor: "#f9fafb",
        transitionDuration: "0.15s",
        transitionProperty: "background-color",
        outlineStyle: "solid",
        outlineWidth: "1px",
        outlineColor: "#e5e7eb",
      },
    },
    cells: {
      style: {
        padding: "16px",
      },
    },
    pagination: {
      style: {
        borderTopWidth: "1px",
        borderTopColor: "#e5e7eb",
        backgroundColor: "white",
        color: "#4b5563",
      },
      pageButtonsStyle: {
        borderRadius: "0.375rem",
        height: "32px",
        width: "32px",
        padding: "4px",
        margin: "0 4px",
        cursor: "pointer",
        transition: "0.2s ease-out",
        color: "#4b5563",
        fill: "#4b5563",
        backgroundColor: "transparent",
        "&:disabled": {
          cursor: "not-allowed",
          color: "#d1d5db",
          fill: "#d1d5db",
        },
        "&:hover:not(:disabled)": {
          backgroundColor: "#f3f4f6",
        },
        "&:focus": {
          outline: "none",
          backgroundColor: "#e5e7eb",
        },
      },
    },
  };

